<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>查询条件</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="sellingCostManageInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-date-picker
                    v-model="sellingCostManageInfo.conditions.beginTime"
                    type="date"
                    placeholder="选择开始时间"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                    v-model="sellingCostManageInfo.conditions.endTime"
                    type="date"
                    placeholder="选择结束时间"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="_querySellingCostMethod">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button type="primary" size="small" @click="_resetSellingCostMethod">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
            </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>销售成本表</div>
      </div>
      <div class="">
            <el-table
              :data="sellingCostManageInfo.sellingCosts"
              border
              style="width: 100%"
            >
              <el-table-column prop="dataTime" label="日期" align="center" />
              <el-table-column prop="salesRevenue" label="销售收入" align="center" />
              <el-table-column prop="salesCost" label="销售成本" align="center" />
              <el-table-column prop="grossMargin" label="销售毛利" align="center" />
              <el-table-column prop="lossMoney" label="亏损金额" align="center" />
              <el-table-column prop="createTime" label="创建时间" align="center" />
            </el-table>

            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="sellingCostManageInfo.conditions.page"
              :page-size="sellingCostManageInfo.conditions.row"
              layout="total, prev, pager, next"
              :total="sellingCostManageInfo.total"
              style="margin-top: 20px; text-align: right"
            />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getSellingCostList } from '@/api/goods/sellingCostManage/sellingCostManageApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'SellingCostManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      sellingCostManageInfo: {
        sellingCosts: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          beginTime: '',
          endTime: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.sellingCostManageInfo.conditions.shopId = getShopId()
    console.log(this.sellingCostManageInfo.records)
    this._listSellingCosts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this._listSellingCosts(val, this.DEFAULT_ROWS)
    },
    async _listSellingCosts(_page, _rows) {
      this.sellingCostManageInfo.conditions.page = _page
      this.sellingCostManageInfo.conditions.row = _rows
      try {
        const res = await getSellingCostList(this.sellingCostManageInfo.conditions)
        this.sellingCostManageInfo.total = res.total
        this.sellingCostManageInfo.records = res.records
        this.sellingCostManageInfo.sellingCosts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _querySellingCostMethod() {
      this._listSellingCosts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetSellingCostMethod() {
      this.sellingCostManageInfo.conditions.beginTime = ''
      this.sellingCostManageInfo.conditions.endTime = ''
      this._listSellingCosts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.card-body {
  padding: 20px;
}
</style>